import { render } from "./BillingAddressCard.vue?vue&type=template&id=a96f3914"
import script from "./BillingAddressCard.vue?vue&type=script&lang=js"
export * from "./BillingAddressCard.vue?vue&type=script&lang=js"

import "./BillingAddressCard.vue?vue&type=style&index=0&id=a96f3914&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__